/* global axios */
import ApiClient from './ApiClient';

class VipLevelsAPI extends ApiClient {
  constructor() {
    super('vip_levels', { accountScoped: true });
  }

  bulkCreate(vipLevels) {
    return axios.post(`${this.url}/bulk_create`, { vip_levels: vipLevels });
  }
}

export default new VipLevelsAPI();
